export const getSource = (url: string) => {
  const urlObj = new URL(url);
  const host = urlObj.hostname;
  if (host.includes('youtube')) {
    return 'youtube';
  }
  return 'unknown';
};

export const formatDate = (date: string) => {
  const dateTime = new Date(date);
  return dateTime.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};
